import { exists } from '@/api'

export interface BatchNrcMarcCatalogRegConditionListItem {
  startNumFrom: string
  startNumTo: string
  rdoMarcType: string
  registrationDate: string
  newPublicationDate: string
  rdoMarcAlreadyExists: string
  isNotCollectionReplace: boolean
  rdoPrice: string
  collectionForm: string
  rdoBunrui: string
  rdoTraderDonor: string
  traderType: string
  donorType: string
  acceptDate: string
  acceptType: string
  budgetYear: string
  budgetBranch: string
  budgetDepartment: string
  expenseCode: string
  equipmentConsumptionCode: string
  isCalcPrice: boolean
  collectionStatus: string
  branchCode: string
  shelfType: string
  collectionType: string
  department: string
  handlingType: string
  storeCode: string
  appendixCode: string
  isCheckDigit: boolean
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchNrcMarcCatalogRegConditionListItemFromJSON(
  json: any
): BatchNrcMarcCatalogRegConditionListItem {
  const resp = JSON.parse(json)

  return {
    startNumFrom: exists(resp, 'start_num_from') ? resp.start_num_from : '',
    startNumTo: exists(resp, 'start_num_to') ? resp.start_num_to : '',
    rdoMarcType: exists(resp, 'rdo_marc_type') ? resp.rdo_marc_type : '2',
    registrationDate: exists(resp, 'registration_date')
      ? resp.registration_date
      : '',
    newPublicationDate: exists(resp, 'new_publication_date')
      ? resp.new_publication_date
      : '',
    rdoMarcAlreadyExists: exists(resp, 'rdo_marc_already_exists')
      ? resp.rdo_marc_already_exists
      : '1',
    isNotCollectionReplace: exists(resp, 'is_not_collection_replace')
      ? resp.is_not_collection_replace
      : false,
    rdoPrice: exists(resp, 'rdo_price') ? resp.rdo_price : '1',
    collectionForm: exists(resp, 'collection_form') ? resp.collection_form : '',
    rdoBunrui: exists(resp, 'rdo_bunrui') ? resp.rdo_bunrui : '9',
    rdoTraderDonor: exists(resp, 'rdo_trader_donor')
      ? resp.rdo_trader_donor
      : '1',
    traderType: exists(resp, 'trader_type') ? resp.trader_type : '',
    donorType: exists(resp, 'donor_type') ? resp.donor_type : '',
    acceptDate: exists(resp, 'accept_date') ? resp.accept_date : '',
    acceptType: resp.accept_type,
    budgetYear: exists(resp, 'budget_year') ? resp.budget_year : '',
    budgetBranch: exists(resp, 'budget_branch') ? resp.budget_branch : '',
    budgetDepartment: exists(resp, 'budget_department')
      ? resp.budget_department
      : '',
    expenseCode: exists(resp, 'expense_code') ? resp.expense_code : '',
    equipmentConsumptionCode: exists(resp, 'equipment_consumption_code')
      ? resp.equipment_consumption_code
      : '',
    isCalcPrice: exists(resp, 'is_calc_price') ? resp.is_calc_price : false,
    collectionStatus: resp.collection_status,
    branchCode: exists(resp, 'branch_code') ? resp.branch_code : '',
    shelfType: exists(resp, 'shelf_type') ? resp.shelf_type : '',
    collectionType: exists(resp, 'collection_type') ? resp.collection_type : '',
    department: exists(resp, 'department') ? resp.department : '',
    handlingType: exists(resp, 'handling_type') ? resp.handling_type : '',
    storeCode: exists(resp, 'store_code') ? resp.store_code : '',
    appendixCode: exists(resp, 'appendix_code') ? resp.appendix_code : '',
    isCheckDigit: exists(resp, 'is_check_digit') ? resp.is_check_digit : false,
    inputFileMarc: '',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
